import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { clsx } from 'clsx';

const MarketQuotes = ({ quotes, isLoading }) => {
  const available = quotes.filter(q => q.available);
  if (isLoading && available.length === 0) return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2">
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="h-16 bg-gray-100 dark:bg-gray-800 rounded-xl animate-pulse" />
      ))}
    </div>
  );
  if (available.length === 0) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2">
      {available.map((q) => {
        const isUp = (q.changePercent ?? 0) >= 0;
        return (
          <div key={q.symbol} className="bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl px-3 py-2.5">
            <div className="text-[11px] font-semibold text-gray-500 dark:text-gray-400 truncate">{q.name}</div>
            <div className="text-sm font-bold text-gray-900 dark:text-white mt-0.5">
              {q.currency === 'BRL'
                ? q.price?.toLocaleString('pt-BR', { maximumFractionDigits: 2 })
                : q.price?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
            <div className={clsx('text-[11px] font-semibold flex items-center gap-0.5 mt-0.5', isUp ? 'text-emerald-500' : 'text-red-500')}>
              {isUp ? <ArrowUpRight size={10} /> : <ArrowDownRight size={10} />}
              {Math.abs(q.changePercent ?? 0).toFixed(2)}%
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MarketQuotes;
